import { matchPath } from 'react-router-dom';

import routes from 'routes/config';

// Whether a URL names a screen this app can actually render.
//
// The guards can't answer that from react-router alone: `/app` is a non-exact parent
// route, so /app/anything matches it, mounts the dashboard frame, and only then finds
// no child to render. Anything under /app therefore *looks* like a destination worth
// authenticating for — which is how a typo ends up sending someone off to the accounts
// app to sign in for a page that does not exist.
//
// Derived from the route table rather than restated, so a route added to config.js is
// known here for free.

// Only leaves carry a renderable path; a parent's path is a prefix its children extend.
const leafRoutes = (list) =>
  list.reduce(
    (acc, route) =>
      route.routes ? acc.concat(leafRoutes(route.routes)) : acc.concat(route),
    []
  );

// The catch-alls are what a URL falls through *to*, so counting them as known paths
// would make every string a known path.
const KNOWN_ROUTES = leafRoutes(routes).filter(
  ({ path }) => path && path !== '*'
);

export const isKnownPath = (pathname) =>
  KNOWN_ROUTES.some(({ path, exact }) => matchPath(pathname, { path, exact }));

export default isKnownPath;
